var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as ServiceUtilisateur from '../../services/utilisateur';
import { useCallback, useEffect, useState } from 'react';
import { Table } from '../../utils/Table';
import { TYPES } from '../../utils/FormikTextField';
import { FormikGenerator } from '../../utils/FormikGenerator';
import { Modal } from '../../utils/Modal';
import { ConfirmDialog } from '../../utils/ConfirmDialog';
import { Stack } from '@mui/material';
import * as ServiceUtils from '../../services/utils';
import { Loader } from '../../utils/Loader';
import { IconButton } from '../../utils/IconButton';
import { DeleteIcon } from '../../utils/Icons';
export var OBJET = {
    COLLABORATEUR: 'Collaborateur',
    GROUPE: 'Groupe',
};
export var UtilisateurVisions = function (_a) {
    var handleClose = _a.handleClose, UtilisateurId = _a.UtilisateurId;
    var _b = useState([]), visions = _b[0], setVisions = _b[1];
    var _c = useState([]), visionsCollaborateurs = _c[0], setVisionsCollaborateurs = _c[1];
    var _d = useState(true), loading = _d[0], setLoading = _d[1];
    var _e = useState([]), collaborateurs = _e[0], setCollaborateurs = _e[1];
    var _f = useState([]), groupes = _f[0], setGroupes = _f[1];
    var getData = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var datas;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        ServiceUtilisateur.getVisions(UtilisateurId),
                        ServiceUtils.getSelectOptions('collaborateurs'),
                        ServiceUtils.getTypes('Groupe'),
                    ])];
                case 1:
                    datas = _a.sent();
                    setVisions(datas[0].visions);
                    setVisionsCollaborateurs(datas[0].collaborateurs);
                    setCollaborateurs(datas[1]);
                    setGroupes(datas[2]);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [UtilisateurId]);
    useEffect(function () {
        getData();
    }, [getData]);
    var handleDelete = function (_a) {
        var IdUtilisateurVision = _a.IdUtilisateurVision;
        return __awaiter(void 0, void 0, void 0, function () {
            var confirmation;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ConfirmDialog({
                            title: 'Suppression',
                            content: 'Êtes-vous sûr de vouloir supprimer cette vision ?',
                            color: 'error',
                        })];
                    case 1:
                        confirmation = _b.sent();
                        if (!confirmation.isOk) return [3 /*break*/, 3];
                        return [4 /*yield*/, ServiceUtilisateur.deleteVision(UtilisateurId, IdUtilisateurVision)];
                    case 2:
                        _b.sent();
                        getData();
                        _b.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ handleCloseModal: handleClose, forceOpen: true, title: "Utilisateur" }, { children: loading ? (_jsx(Loader, {})) : (_jsxs(Stack, __assign({ spacing: 2 }, { children: [_jsx(FormikGenerator, { submitLabel: "Ajouter", fields: [], onSubmit: function (_a) {
                            var Objet = _a.Objet, CollaborateurId = _a.CollaborateurId, GroupeId = _a.GroupeId;
                            return __awaiter(void 0, void 0, void 0, function () {
                                var ObjetId;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            ObjetId = null;
                                            switch (Objet) {
                                                case OBJET.COLLABORATEUR: {
                                                    ObjetId = CollaborateurId;
                                                    break;
                                                }
                                                case OBJET.GROUPE: {
                                                    ObjetId = GroupeId;
                                                    break;
                                                }
                                                default:
                                                    break;
                                            }
                                            return [4 /*yield*/, ServiceUtilisateur.postVision({
                                                    UtilisateurId: UtilisateurId,
                                                    ObjetId: ObjetId,
                                                    Objet: Objet,
                                                })];
                                        case 1:
                                            _b.sent();
                                            getData();
                                            return [2 /*return*/];
                                    }
                                });
                            });
                        }, renderContent: function (_a) {
                            var values = _a.values, renderField = _a.renderField, setFieldValue = _a.setFieldValue;
                            return (_jsxs(Stack, __assign({ direction: "row", padding: 2, spacing: 2 }, { children: [renderField({
                                        label: 'Type',
                                        name: 'Objet',
                                        type: TYPES.SELECT,
                                        options: [
                                            {
                                                label: OBJET.COLLABORATEUR,
                                                value: OBJET.COLLABORATEUR,
                                            },
                                            { label: OBJET.GROUPE, value: OBJET.GROUPE },
                                        ],
                                    }), values.Objet === OBJET.COLLABORATEUR &&
                                        renderField({
                                            label: 'Collaborateur',
                                            name: 'CollaborateurId',
                                            type: TYPES.SELECT,
                                            options: collaborateurs ? collaborateurs : [],
                                        }), values.Objet === OBJET.GROUPE &&
                                        renderField({
                                            label: 'Groupe',
                                            name: 'GroupeId',
                                            type: TYPES.SELECT,
                                            options: groupes ? groupes : [],
                                        })] })));
                        } }), _jsx(Table, { headers: [
                            {
                                label: 'Visions',
                                assessor: 'Libelle',
                            },
                            {
                                minWidth: true,
                                component: function (value) { return (_jsx(IconButton, __assign({ color: "error", tooltip: "Supprimer", onClick: function () { return handleDelete(value); } }, { children: _jsx(DeleteIcon, {}) }))); },
                            },
                        ], datas: visions ? visions : [] }), _jsx(Table, { headers: [
                            {
                                label: 'Visiblité sur les collaborateurs suivants',
                                assessor: 'getLibelle',
                            },
                        ], datas: visionsCollaborateurs ? visionsCollaborateurs : [] })] }))) })) }));
};
//# sourceMappingURL=UtilisateurVisions.js.map